import script from "./productDealsCopy.vue?vue&type=script&setup=true&lang=js"
export * from "./productDealsCopy.vue?vue&type=script&setup=true&lang=js"

import "./productDealsCopy.vue?vue&type=style&index=0&id=39af2f55&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39af2f55"]])

export default __exports__